import React from "react"
import { StyledNavItemIcon } from "./styles"

const NavItemIcon: React.FC<{ icon: React.ReactNode }> = ({ icon }) => {
  return <StyledNavItemIcon>{icon} 
  {/* <FaTwitter/> */}
  </StyledNavItemIcon>;
};

export default NavItemIcon